module.exports = {"350603001":"步文街道","350603002":"碧湖街道","350603100":"蓝田镇","350603102":"朝阳镇","350603103":"郭坑镇","350603500":"蓝田开发区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350603.json
// module id = 1210
// module chunks = 0